import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/free-solid-svg-icons";

export const Gallery = () => {
  const googleDriveLinks = [
    {
      url: "https://drive.google.com/drive/u/1/folders/1TgPzoz_YlVjhTm2ZswE0TFhTNGK0fWqi",
      title: "Ferry Anggeriawan",
      instagram: "ferri_mt2",
    },
    {
      url: "https://drive.google.com/drive/u/1/folders/1XCpornWtp_cw-6XpttEspohf00bkh2D1",
      title: "Algi Ramadhan",
      instagram: "downcapture",
    },
    {
      url: "https://drive.google.com/drive/u/1/folders/1q0dPsgKJ92DVGlVg2_T0F5vCscaODf8L",
      title: "Fahmi Eka",
      instagram: "empat.langkah",
    },
    {
      url: "https://drive.google.com/drive/u/1/folders/1Q4BhDMn2Ed-cNjcwNx_VNOHEq9jcRjnF",
      title: "Muhammad Fadhli",
      instagram: "fadhlimotret",
    },
    {
      url: "https://drive.google.com/drive/u/1/folders/1RFL3Le0elE_0dGBQEqb0Qpqim2sg0a0-",
      title: "Firman Ramadhy",
      instagram: "firmanramadhy",
    },
    {
      url: "https://drive.google.com/drive/u/1/folders/1xOWcff7GdyjHOYZJvNTBw7gR0wSP4D0C",
      title: "Hilda Hanifa",
      instagram: "hildahanifaa",
    },
    {
      url: "https://drive.google.com/drive/u/1/folders/1j6fi1vvGzfrS7r_PkcqRV-UFNJK6zTvC",
      title: "Sultan",
      instagram: "kejar_kejarrun",
    },
    {
      url: "https://drive.google.com/drive/u/1/folders/1bT0Y1gzDfG_XHur6C0Bs3SfaK-YORjf_",
      title: "Rafly Iskandar",
      instagram: "Raflyiskandar_",
    },
    {
      url: "https://drive.google.com/drive/u/1/folders/1dwQYXWhjIdocHAONjcY6mordwzaCXcV7",
      title: "Siharyo",
      instagram: "siharyo",
    },
    {
      url: "https://drive.google.com/drive/u/1/folders/11NEBEIghGalrMkTQ-VHL5rpQStw6bk6l",
      title: "Cahyo Sulistyo",
      instagram: "sulistyo.cahyo",
    },
  ];

  return (
    <section
      id="gallery"
      className="w-full min-h-screen py-20 text-center text-lime-600 flex flex-col justify-center relative bg-white"
    >
      <div className="relative z-0 container mx-auto px-4">
        <div className="max-w-7xl mx-auto space-y-4">
          {/* Full-width Information Container */}
          <motion.div
            className="bg-white rounded-2xl border border-gray-200 px-6 py-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl md:text-3xl font-bold text-lime-600 mb-4">
              Photo Gallery
            </h2>
            <p className="text-base text-gray-600 max-w-5xl mx-auto">
              The process of uploading photos to each Google Drive folder is currently ongoing. 
              We are continuously adding files gradually to ensure all documentation is stored 
              neatly and is easily accessible. Please check back periodically to see the latest updates.
            </p>
          </motion.div>

          {/* Photo Links Grid */}
          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            {googleDriveLinks.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white rounded-xl px-6 py-8 border border-gray-200 flex flex-col items-center justify-center hover:shadow-lg transition-shadow duration-200"
              >
                <FontAwesomeIcon
                  icon={faImages}
                  className="text-4xl text-lime-600 mb-4"
                />
                <p className="text-lg text-lime-600 font-semibold hover:underline">
                  {link.title}
                </p>
                <a
                  href={`https://www.instagram.com/${link.instagram}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 mt-1 hover:underline"
                >
                  @{link.instagram}
                </a>
                {/*  <p className="text-sm text-gray-600 mt-2">
                  View photos on Google Drive
                </p> */}
              </a>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};
